import { RouteProp } from '@react-navigation/native';
import React from 'react';
import useMedicalProfile from '../../../../../hooks/api/useMedicalProfile';
import { getIntl } from '../../../../../utils/intl';
import { ProfilesTabParamList, useProfilesTabNavigation } from '../../../../../utils/appNavigationNames';
import { AnimateLoadedContent } from '../../../../v2BaseComponents/Loader';
import MainContentContainer from '../../../../v2BaseComponents/MainContentContainer';
import { ContentStack } from '../../../../v2BaseComponents/Stack';
import * as Card from '../../../../v2BaseComponents/Card';
import getName from '../../../../../utils/getName';
import { ActionButtonLayout } from '../../../../v2BaseComponents/ActionButtonLayout';
import ProfileHeaderContainer from '../../../../v2BaseComponents/ProfileHeaderContainer';

const intl = getIntl('emergencyContactList', {
    header: 'Click on a contact to edit',
    add: 'Add Emergency Contact',
    fallbackName: 'Emergency Contact #{number}',
});

export type EmergencyContactListOwnProps = {};

export type EmergencyContactListProps = EmergencyContactListOwnProps & {
    route: RouteProp<ProfilesTabParamList, 'emergency-contacts'>;
};

const EmergencyContactListScreen: React.FC<EmergencyContactListProps> = (props) => {
    const { isLoadingProfile, profile } = useMedicalProfile({ medicalProfileId: props.route.params.profileId });
    const navigation = useProfilesTabNavigation();

    return (
        <ProfileHeaderContainer profileId={props.route.params.profileId} bottomBorder>
            <AnimateLoadedContent isLoading={isLoadingProfile}>
                {() => (
                    <ActionButtonLayout
                        actions={[
                            {
                                title: intl('add'),
                                onPress: () =>
                                    navigation.navigate('create-emergency-contact', {
                                        profileId: props.route.params.profileId,
                                    }),
                                icon: 'Plus',
                            },
                        ]}
                    >
                        <MainContentContainer style={{ flex: 1, alignSelf: 'stretch' }}>
                            <ContentStack>
                                {(profile?.emergencyContactDetails || []).map((contact, index) => (
                                    <Card.Card
                                        key={contact.contactDetailsId}
                                        onPress={() =>
                                            navigation.navigate('edit-emergency-contact', {
                                                profileId: props.route.params.profileId,
                                                emergencyContactId: contact.contactDetailsId,
                                            })
                                        }
                                    >
                                        <Card.CardContent>
                                            <Card.CardHeader>
                                                {getName(contact) || intl('fallbackName', { number: index + 1 })}
                                            </Card.CardHeader>
                                        </Card.CardContent>
                                    </Card.Card>
                                ))}
                            </ContentStack>
                        </MainContentContainer>
                    </ActionButtonLayout>
                )}
            </AnimateLoadedContent>
        </ProfileHeaderContainer>
    );
};

export default React.memo(EmergencyContactListScreen);
